import colors from "../base/colors";

const { text } = colors;

const typographyx = {
    styleOverrides: {
        root: {
            color: text.main,
        },
    },
}

export default typographyx